import { getBearerToken } from "./index";
import OktaAuth from "@okta/okta-auth-js";
import { ModerationAction, GetReportsResponse, ReportDTO } from "../models/moderation";
import { getConfig } from "../config";

function moderationServiceURL(urlSuffix: string): string {
  const config = getConfig();
  return `${config.apiBaseUrl}/moderation/v1${urlSuffix}`;
}

function getModerationServiceAuthHeaders(okta?: OktaAuth): { [key: string]: string } {
  return {
    Authorization: getBearerToken(okta)
  };
}

export async function fetchReports(okta?: OktaAuth) {
  const resp = await fetch(moderationServiceURL(`/reports?limit=50`), {
    method: 'GET',
    headers: getModerationServiceAuthHeaders(okta),
  });
  const data: GetReportsResponse = await resp.json();
  return data.reports;
}

export async function pushActionToBackend(reportID: string, action: ModerationAction, okta: OktaAuth) {
  const resp = await fetch(moderationServiceURL(`/reports/${reportID}/actions`), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...getModerationServiceAuthHeaders(okta),
    },
    body: JSON.stringify({
      action,
    }),
  });

  type APIResponse = {
    report: ReportDTO;
  };

  const data: APIResponse = await resp.json();
  return data.report;
}
